var chunkMapping = {
	"vendors-node_modules_pnpm_umijs_bundler-webpack_4_6_9__types_webpack_5_28_5_type-fest_1_4_0_t-88e6b0": [
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/@umijs+utils@4.6.9/node_modules/@umijs/utils/compiled/strip-ansi/index.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/react-error-overlay@6.0.9/node_modules/react-error-overlay/lib/index.js"
	],
	"vendors-node_modules_pnpm_babel_runtime_7_23_6_node_modules_babel_runtime_helpers_asyncToGene-8a1446": [
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/antd/dist/reset.css",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/@umijs+renderer-react@4.6.9_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@umijs/renderer-react",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/umi@4.6.9_@babel+core@7.23.6_@types+node@25.0.3_@types+react@18.3.27_@types+webpack@5.28.5_es_ev5lwapux6owcgw4jfya4q4w6y/node_modules/umi/client/client/plugin.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.error.cause.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.aggregate-error.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.aggregate-error.cause.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.at.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.find-last.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.find-last-index.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.push.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.reduce.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.reduce-right.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.to-reversed.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.to-sorted.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.to-spliced.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.with.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.map.group-by.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.object.group-by.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.object.has-own.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.promise.any.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.promise.with-resolvers.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.reflect.to-string-tag.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.regexp.flags.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.at-alternative.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.is-well-formed.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.replace-all.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.to-well-formed.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.at.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.find-last.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.find-last-index.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.set.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.to-reversed.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.to-sorted.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.with.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.suppressed-error.constructor.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.from-async.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.filter-out.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.filter-reject.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group-by.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group-by-to-map.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group-to-map.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.is-template-object.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.last-index.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.last-item.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.unique-by.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array-buffer.detached.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array-buffer.transfer.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array-buffer.transfer-to-fixed-length.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-disposable-stack.constructor.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.constructor.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.as-indexed-pairs.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.async-dispose.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.drop.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.every.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.filter.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.find.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.flat-map.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.for-each.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.from.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.indexed.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.map.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.reduce.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.some.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.take.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.to-array.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.bigint.range.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.composite-key.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.composite-symbol.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.get-float16.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.get-uint8-clamped.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.set-float16.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.set-uint8-clamped.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.disposable-stack.constructor.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.demethodize.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.is-callable.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.is-constructor.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.metadata.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.un-this.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.constructor.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.as-indexed-pairs.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.dispose.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.drop.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.every.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.filter.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.find.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.flat-map.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.for-each.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.from.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.indexed.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.map.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.range.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.reduce.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.some.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.take.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.to-array.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.to-async.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.json.is-raw-json.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.json.parse.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.json.raw-json.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.delete-all.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.emplace.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.every.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.filter.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.find.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.find-key.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.from.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.includes.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.key-by.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.key-of.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.map-keys.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.map-values.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.merge.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.of.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.reduce.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.some.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.update.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.update-or-insert.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.upsert.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.clamp.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.deg-per-rad.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.degrees.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.fscale.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.f16round.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.iaddh.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.imulh.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.isubh.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.rad-per-deg.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.radians.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.scale.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.seeded-prng.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.signbit.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.umulh.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.number.from-string.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.number.range.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.object.iterate-entries.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.object.iterate-keys.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.object.iterate-values.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.observable.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.promise.try.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.define-metadata.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.delete-metadata.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-metadata.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-own-metadata.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.has-metadata.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.has-own-metadata.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.metadata.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.regexp.escape.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.add-all.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.delete-all.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.difference.v2.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.difference.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.every.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.filter.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.find.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.from.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.intersection.v2.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.intersection.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-disjoint-from.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-subset-of.v2.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-subset-of.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-superset-of.v2.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-superset-of.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.join.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.map.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.of.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.reduce.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.some.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.symmetric-difference.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.union.v2.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.union.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.at.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.cooked.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.code-points.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.dedent.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.async-dispose.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.dispose.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-registered-symbol.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-registered.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-well-known-symbol.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-well-known.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.matcher.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.metadata.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.metadata-key.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.observable.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.pattern-match.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.replace-all.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.from-async.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.filter-out.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.filter-reject.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.group-by.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.to-spliced.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.unique-by.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.from-base64.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.from-hex.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.to-base64.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.to-hex.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.delete-all.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.from.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.of.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.emplace.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.upsert.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.add-all.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.delete-all.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.from.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.of.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.dom-exception.stack.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.immediate.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.self.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.structured-clone.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url.can-parse.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url-search-params.delete.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url-search-params.has.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url-search-params.size.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/regenerator-runtime@0.13.11/node_modules/regenerator-runtime/runtime.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/react@18.3.1/node_modules/react",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-dev-runtime",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/axios@0.27.2/node_modules/axios",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/@ahooksjs+use-request@2.8.15_react@18.3.1/node_modules/@ahooksjs/use-request"
	],
	"vendors-webpack_container_remote_mf_app_data_stock-mirror_web_node_modules_antd": [
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/antd"
	],
	"webpack_container_remote_mf_ant-design_pro-components": [
		"webpack/container/remote/mf/@ant-design/pro-components"
	],
	"webpack_container_remote_mf_ant-design_plots-webpack_container_remote_mf_dayjs": [
		"webpack/container/remote/mf/@ant-design/plots",
		"webpack/container/remote/mf/dayjs"
	],
	"vendors-webpack_container_remote_mf_app_data_stock-mirror_web_node_modules_pnpm_ant-design_ic-36a72a": [
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@ant-design/icons",
		"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/@ant-design/pro-components"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/@umijs+utils@4.6.9/node_modules/@umijs/utils/compiled/strip-ansi/index.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/@umijs+utils@4.6.9/node_modules/@umijs/utils/compiled/strip-ansi/index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/react-error-overlay@6.0.9/node_modules/react-error-overlay/lib/index.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/react-error-overlay@6.0.9/node_modules/react-error-overlay/lib/index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/antd/dist/reset.css": [
		"default",
		".//app/data/stock-mirror/web/node_modules/antd/dist/reset.css",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/@umijs+renderer-react@4.6.9_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@umijs/renderer-react": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/@umijs+renderer-react@4.6.9_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@umijs/renderer-react",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/umi@4.6.9_@babel+core@7.23.6_@types+node@25.0.3_@types+react@18.3.27_@types+webpack@5.28.5_es_ev5lwapux6owcgw4jfya4q4w6y/node_modules/umi/client/client/plugin.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/umi@4.6.9_@babel+core@7.23.6_@types+node@25.0.3_@types+react@18.3.27_@types+webpack@5.28.5_es_ev5lwapux6owcgw4jfya4q4w6y/node_modules/umi/client/client/plugin.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.error.cause.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.error.cause.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.aggregate-error.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.aggregate-error.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.aggregate-error.cause.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.aggregate-error.cause.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.at.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.at.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.find-last.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.find-last.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.find-last-index.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.find-last-index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.push.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.push.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.reduce.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.reduce-right.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.reduce-right.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.to-reversed.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.to-reversed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.to-sorted.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.to-sorted.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.to-spliced.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.to-spliced.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.with.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.array.with.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.map.group-by.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.map.group-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.object.group-by.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.object.group-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.object.has-own.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.object.has-own.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.promise.any.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.promise.any.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.promise.with-resolvers.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.promise.with-resolvers.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.reflect.to-string-tag.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.reflect.to-string-tag.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.regexp.flags.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.regexp.flags.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.at-alternative.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.at-alternative.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.is-well-formed.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.is-well-formed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.replace-all.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.replace-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.to-well-formed.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.string.to-well-formed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.at.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.at.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.find-last.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.find-last.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.find-last-index.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.find-last-index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.set.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.set.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.to-reversed.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.to-reversed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.to-sorted.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.to-sorted.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.with.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/es.typed-array.with.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.suppressed-error.constructor.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.suppressed-error.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.from-async.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.from-async.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.filter-out.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.filter-out.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.filter-reject.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.filter-reject.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group-by.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group-by-to-map.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group-by-to-map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group-to-map.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.group-to-map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.is-template-object.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.is-template-object.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.last-index.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.last-index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.last-item.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.last-item.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.unique-by.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array.unique-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array-buffer.detached.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array-buffer.detached.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array-buffer.transfer.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array-buffer.transfer.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array-buffer.transfer-to-fixed-length.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.array-buffer.transfer-to-fixed-length.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-disposable-stack.constructor.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-disposable-stack.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.constructor.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.as-indexed-pairs.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.as-indexed-pairs.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.async-dispose.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.async-dispose.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.drop.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.drop.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.every.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.every.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.filter.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.filter.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.find.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.find.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.flat-map.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.flat-map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.for-each.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.for-each.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.from.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.indexed.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.indexed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.map.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.reduce.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.some.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.some.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.take.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.take.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.to-array.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.async-iterator.to-array.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.bigint.range.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.bigint.range.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.composite-key.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.composite-key.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.composite-symbol.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.composite-symbol.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.get-float16.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.get-float16.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.get-uint8-clamped.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.get-uint8-clamped.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.set-float16.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.set-float16.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.set-uint8-clamped.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.data-view.set-uint8-clamped.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.disposable-stack.constructor.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.disposable-stack.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.demethodize.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.demethodize.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.is-callable.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.is-callable.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.is-constructor.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.is-constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.metadata.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.un-this.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.function.un-this.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.constructor.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.constructor.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.as-indexed-pairs.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.as-indexed-pairs.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.dispose.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.dispose.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.drop.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.drop.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.every.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.every.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.filter.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.filter.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.find.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.find.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.flat-map.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.flat-map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.for-each.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.for-each.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.from.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.indexed.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.indexed.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.map.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.range.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.range.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.reduce.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.some.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.some.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.take.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.take.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.to-array.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.to-array.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.to-async.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.iterator.to-async.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.json.is-raw-json.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.json.is-raw-json.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.json.parse.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.json.parse.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.json.raw-json.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.json.raw-json.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.delete-all.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.delete-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.emplace.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.emplace.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.every.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.every.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.filter.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.filter.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.find.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.find.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.find-key.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.find-key.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.from.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.includes.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.includes.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.key-by.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.key-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.key-of.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.key-of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.map-keys.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.map-keys.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.map-values.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.map-values.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.merge.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.merge.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.of.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.reduce.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.some.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.some.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.update.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.update.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.update-or-insert.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.update-or-insert.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.upsert.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.map.upsert.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.clamp.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.clamp.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.deg-per-rad.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.deg-per-rad.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.degrees.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.degrees.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.fscale.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.fscale.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.f16round.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.f16round.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.iaddh.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.iaddh.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.imulh.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.imulh.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.isubh.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.isubh.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.rad-per-deg.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.rad-per-deg.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.radians.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.radians.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.scale.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.scale.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.seeded-prng.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.seeded-prng.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.signbit.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.signbit.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.umulh.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.math.umulh.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.number.from-string.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.number.from-string.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.number.range.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.number.range.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.object.iterate-entries.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.object.iterate-entries.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.object.iterate-keys.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.object.iterate-keys.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.object.iterate-values.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.object.iterate-values.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.observable.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.observable.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.promise.try.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.promise.try.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.define-metadata.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.define-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.delete-metadata.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.delete-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-metadata.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-own-metadata.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-own-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.has-metadata.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.has-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.has-own-metadata.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.has-own-metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.metadata.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.reflect.metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.regexp.escape.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.regexp.escape.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.add-all.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.add-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.delete-all.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.delete-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.difference.v2.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.difference.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.difference.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.difference.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.every.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.every.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.filter.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.filter.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.find.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.find.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.from.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.intersection.v2.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.intersection.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.intersection.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.intersection.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-disjoint-from.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-disjoint-from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-subset-of.v2.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-subset-of.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-subset-of.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-subset-of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-superset-of.v2.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-superset-of.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-superset-of.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.is-superset-of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.join.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.join.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.map.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.map.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.of.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.reduce.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.reduce.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.some.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.some.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.symmetric-difference.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.symmetric-difference.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.union.v2.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.union.v2.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.union.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.set.union.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.at.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.at.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.cooked.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.cooked.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.code-points.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.code-points.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.dedent.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.string.dedent.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.async-dispose.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.async-dispose.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.dispose.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.dispose.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-registered-symbol.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-registered-symbol.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-registered.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-registered.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-well-known-symbol.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-well-known-symbol.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-well-known.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.is-well-known.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.matcher.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.matcher.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.metadata.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.metadata.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.metadata-key.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.metadata-key.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.observable.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.observable.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.pattern-match.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.pattern-match.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.replace-all.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.symbol.replace-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.from-async.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.from-async.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.filter-out.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.filter-out.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.filter-reject.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.filter-reject.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.group-by.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.group-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.to-spliced.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.to-spliced.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.unique-by.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.typed-array.unique-by.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.from-base64.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.from-base64.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.from-hex.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.from-hex.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.to-base64.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.to-base64.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.to-hex.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.uint8-array.to-hex.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.delete-all.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.delete-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.from.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.of.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.emplace.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.emplace.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.upsert.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-map.upsert.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.add-all.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.add-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.delete-all.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.delete-all.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.from.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.from.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.of.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/esnext.weak-set.of.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.dom-exception.stack.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.dom-exception.stack.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.immediate.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.immediate.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.self.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.self.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.structured-clone.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.structured-clone.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url.can-parse.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url.can-parse.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url-search-params.delete.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url-search-params.delete.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url-search-params.has.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url-search-params.has.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url-search-params.size.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/core-js@3.34.0/node_modules/core-js/modules/web.url-search-params.size.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/regenerator-runtime@0.13.11/node_modules/regenerator-runtime/runtime.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/regenerator-runtime@0.13.11/node_modules/regenerator-runtime/runtime.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/react@18.3.1/node_modules/react": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/react@18.3.1/node_modules/react",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-dev-runtime": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-dev-runtime",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/axios@0.27.2/node_modules/axios": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/axios@0.27.2/node_modules/axios",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/@ahooksjs+use-request@2.8.15_react@18.3.1/node_modules/@ahooksjs/use-request": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/@ahooksjs+use-request@2.8.15_react@18.3.1/node_modules/@ahooksjs/use-request",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/antd": [
		"default",
		".//app/data/stock-mirror/web/node_modules/antd",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf/@ant-design/pro-components": [
		"default",
		"./@ant-design/pro-components",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf/@ant-design/plots": [
		"default",
		"./@ant-design/plots",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf/dayjs": [
		"default",
		"./dayjs",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@ant-design/icons": [
		"default",
		".//app/data/stock-mirror/web/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@ant-design/icons",
		"webpack/container/reference/mf"
	],
	"webpack/container/remote/mf//app/data/stock-mirror/web/node_modules/@ant-design/pro-components": [
		"default",
		".//app/data/stock-mirror/web/node_modules/@ant-design/pro-components",
		"webpack/container/reference/mf"
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}